
import axios from "axios";
import { API_URL } from "../config/constants";

// const API_URL = "http://localhost:5000/api/auth/";

const END_POINT = `${API_URL}settings/`

export const getOneAccount = async () => {
    try {
        const token = localStorage.getItem('jwtToken');
        if (!token) {
            console.log("Token missing!");
            return null;
        }

        return await axios.get(`${END_POINT}get-one-setting`
            , {
            headers: {
                Authorization: `Bearer ${token}`
               
            },

        }
    );
    } catch (error) {
        console.error("Error fetching setting:", error);
        return null;
    }
};


export const updateAccount = async(name,email,phone) => {
    try {
        const token =  localStorage.getItem('jwtToken');
        if (!token) {
            console.log("Token missing!");
            return null;
        }
    return await axios.put(`${END_POINT}update-setting`
        ,
            {name,email,phone}
            ,{
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        )
       
        
    } catch (error) {
        console.error("Error fetching setting:", error);
        return null;
    }
};